import { Token } from 'config/types'
import { useMemo } from 'react'
import { useListNetworks, useListTokens, useTokenPriorities } from 'state/app/hooks'
import { PaymentPageEnums } from 'views/Payment/Menu'

export const useTokensWithSameCode = (needCheckToken: Token, from?: PaymentPageEnums): Token[] | [] => {
  const listToken = useListTokens()
  const networkList = useListNetworks()
  const { handleSortTokens } = useTokenPriorities({
    from,
  })

  return useMemo(() => {
    return handleSortTokens(listToken.filter((appToken) => appToken.code === needCheckToken?.code) || [])
  }, [needCheckToken, listToken, networkList, handleSortTokens])
}
